export default function ProgressBar({ title, percentage }) {
  return (
    <div className="mb-6">
      <div className="flex justify-between mb-2 text-sm">
        <span className="text-[#D9D2C2]">{title}</span>
        <span className="font-display text-[#D4AF6A]">{percentage}%</span>
      </div>
      <div className="shimmer bg-white/5 h-[6px] w-full rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{
            width: `${percentage}%`,
            background: "linear-gradient(90deg, #8a6a35, #D4AF6A, #f2dfb4)",
          }}
        ></div>
      </div>
    </div>
  );
}
